/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { forwardRef } from 'react';
import { labelStyles } from '@zapier/style-encapsulation';

import { MEDIA_MIN_WIDTH } from '../../../constants';
import { LottieAnimation, LottieAnimationMethods } from '../../LottieAnimation';
import { useAnimationsSectionContext } from './Context';

type Props = {
  animationAssetsUrl?: string;
  animationDataUrl: string;
  animationSpeed?: number;
  ariaLabel: string;
  autoPlay: boolean;
  isVisible: boolean;
};

const Styles = labelStyles('Animation', {
  root: (isVisible: boolean) =>
    css({
      opacity: isVisible ? 1 : 0,
      visibility: isVisible ? 'visible' : 'hidden',
      transition: 'visibility 0.5s, opacity 0.5s linear',
      margin: 'auto',
      position: 'relative',
      width: '70vw',
      [MEDIA_MIN_WIDTH.small]: {
        width: '40vw',
      },
      [MEDIA_MIN_WIDTH.medium]: {
        width: '35vw',
      },
      [MEDIA_MIN_WIDTH.large]: {
        width: '30vw',
        position: 'absolute',
      },
    }),
});

export const Animation = forwardRef<LottieAnimationMethods, Props>(
  (
    {
      ariaLabel,
      animationAssetsUrl,
      animationDataUrl,
      animationSpeed,
      autoPlay,
      isVisible,
    },
    ref,
  ) => {
    const { isViewportSizeKnown } = useAnimationsSectionContext();

    return isViewportSizeKnown ? (
      <div css={Styles.root(isVisible)}>
        <LottieAnimation
          animationAssetsUrl={animationAssetsUrl}
          animationDataUrl={animationDataUrl}
          ariaLabel={ariaLabel}
          autoplay={autoPlay}
          loop={false}
          ref={ref}
          speed={animationSpeed}
        />
      </div>
    ) : null;
  },
);
